import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-envio-correcto',
  standalone: true,
  imports: [],
  templateUrl: './modal-envio-correcto.component.html',
  styleUrl: './modal-envio-correcto.component.css',
})
export class ModalEnvioCorrectoComponent {
  @Input() isOpen = false;
  @Input() message = '';
  @Output() continue = new EventEmitter<void>();

  isClosing = false;

  onContinue(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.continue.emit();
      this.isClosing = false;
    }, 300);
  }
}
